import { Link } from 'react-router-dom';
import { isExternalTarget, resolveNavTarget } from './navigationPaths';

/**
 * Renders an internal route, homepage section hash, or external anchor.
 */
function NavTargetLink({ target, className, children, onNavigate }) {
  if (isExternalTarget(target)) {
    return (
      <a
        href={target.href}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onNavigate}
      >
        {children}
      </a>
    );
  }

  const to = resolveNavTarget(target);
  return (
    <Link to={to} className={className} onClick={onNavigate}>
      {children}
    </Link>
  );
}

export default NavTargetLink;
